const PuzzleStatus = {};
export default PuzzleStatus;

PuzzleStatus.NONE = "NONE";
PuzzleStatus.STARTED = "STARTED";
PuzzleStatus.FAILED = "FAILED";
PuzzleStatus.COMPLETED = "COMPLETED";
PuzzleStatus.TIMEOUT = "TIMEOUT";